import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex flex-wrap -m-1" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]

import { toRefs } from 'vue';
import { NftMetadataAttribute } from '@/models';


export default /*#__PURE__*/_defineComponent({
  props: {
    attributes: null
  },
  setup(__props: any) {

const props = __props as {
  attributes: NftMetadataAttribute,
}



const { attributes } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_unref(attributes)?.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(attributes), (attribute, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "border px-2 py-0.5 rounded m-1"
            }, [
              _createElementVNode("div", {
                class: "text-xs text-gray-400 font-medium",
                textContent: _toDisplayString(attribute.trait_type)
              }, null, 8, _hoisted_3),
              _createElementVNode("div", {
                class: "text-sm",
                textContent: _toDisplayString(attribute.value)
              }, null, 8, _hoisted_4)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})